<template>
  <div>
    <form @submit.prevent="submitSupplier">
      <v-row>
        <v-col
          cols="12"
          md="8"
          sm="12"
        >
          <v-card outlined>
            <v-card-text>
              <div>General</div>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  sm="12"
                >
                  <v-text-field
                    v-model="supplier.firstName"
                    hide-details="auto"
                    label="First Name"
                    outlined
                    dense
                    :error-messages="errors.getMessage('firstName')"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  sm="12"
                >
                  <v-text-field
                    v-model="supplier.lastName"
                    hide-details="auto"
                    label="Last Name"
                    outlined
                    dense
                    :error-messages="errors.getMessage('lastName')"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  sm="12"
                >
                  <v-text-field
                    v-model="supplier.dateOfBirth"
                    hide-details="auto"
                    label="Date Of Birth"
                    type="date"
                    outlined
                    dense
                    :error-messages="errors.getMessage('dateOfBirth')"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  sm="12"
                >
                  <v-select
                    v-model="supplier.gender"
                    :items="['Male', 'Female']"
                    item-text="name"
                    outlined
                    label="Gender"
                    dense
                    :error-messages="errors.getMessage('gender')"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card
            outlined
            class="mt-3"
          >
            <v-card-text>
              <div>Business information</div>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  sm="12"
                >
                  <v-text-field
                    v-model="supplier.company"
                    hide-details="auto"
                    label="Company"
                    outlined
                    dense
                    :error-messages="errors.getMessage('company')"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  sm="12"
                >
                  <v-text-field
                    v-model="supplier.identification"
                    hide-details="auto"
                    label="Identification"
                    outlined
                    dense
                    :error-messages="errors.getMessage('identification')"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    v-model="supplier.taxId"
                    hide-details="auto"
                    label="Tax Id"
                    outlined
                    dense
                    :error-messages="errors.getMessage('taxId')"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-textarea
                    v-model="supplier.companyAddress"
                    hide-details="auto"
                    label="Company Address"
                    outlined
                    rows="3"
                    dense
                    :error-messages="errors.getMessage('companyAddress')"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-textarea
                    v-model="supplier.shippingAdress"
                    hide-details="auto"
                    label="Shipping Adress"
                    outlined
                    rows="3"
                    dense
                    :error-messages="errors.getMessage('shippingAdress')"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="4"
          sm="12"
        >
          <v-card outlined>
            <v-card-text>
              <div>Contact Information</div>
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="supplier.email"
                  hide-details="auto"
                  label="Email"
                  outlined
                  dense
                  :error-messages="errors.getMessage('email')"
                />
              </v-col>
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="supplier.phone"
                  hide-details="auto"
                  label="Phone"
                  outlined
                  dense
                  :error-messages="errors.getMessage('phone')"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="supplier.address"
                  label="Address"
                  outlined
                  rows="3"
                  dense
                />
              </v-col>
            </v-card-text>
          </v-card>
          <div class="text-center">
            <v-btn
              color="green"
              class="ma-2 white--text"
              type="submit"
            >
              Save
              <v-icon
                right
                dark
              >
                mdi-plus
              </v-icon>
            </v-btn>
            <v-btn
              class="ma-2"
              :to="{ name: 'SuppliersList' }"
            >
              Cancel
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      edit: false,
      supplier: {},
    };
  },
  computed: {
    ...mapGetters({
      errors: "validation/pull",
    }),
  },
  mounted() {
    if (this.$route.params.id) {
      this.getFromApi();
    }
  },
  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),

    redirect(info) {
      this.feedback(info.data.message);
      this.$router.replace({ name: "SuppliersList" });
    },
    updateSupplier() {
      let data = this.$data.supplier;
      window.axios.patch("/supplier/" + data.id, data).then((response) => {
        this.redirect(response);
      });
    },
    createSupplier() {
      window.axios.post("/supplier", this.$data.supplier).then((response) => {
        this.redirect(response);
      });
    },
    submitSupplier() {
      if (this.$data.edit) {
        this.updateSupplier();
      } else {
        this.createSupplier();
      }
    },
    getFromApi() {
      window.axios
        .get("/supplier/" + this.$route.params.id)
        .then((response) => {
          this.$data.supplier = response.data.supplier;
          this.$data.edit = true;
        });
    },
  },
};
</script>
